import { connect } from 'react-redux'
import { IStateProps } from './YumLogActivity'
import YumLogActivity from './YumLogActivity'
import { IGlobalState } from '../../Root/store/appReducer'
import { GoalWithProgress } from '../../services/api.types'

export interface IOwnProps {
  goal: GoalWithProgress
  disabled: boolean
  autoClose: boolean
}

const mapStateToProps = (state: IGlobalState, ownProps: IOwnProps): IStateProps => {
  const { goal, disabled, autoClose } = ownProps
  return {
    goal,
    disabled,
    autoClose,
  }
}

export default connect(mapStateToProps)(YumLogActivity)
